import React from 'react';
import { Pill } from 'web-library';
import { PaymentStatus } from '../../models/PaymentStatus';

interface IPaymentStatusPill {
  paymentStatus: PaymentStatus;
}

const PaymentStatusPill = ({ paymentStatus }: IPaymentStatusPill) => (
  <>
    {paymentStatus === PaymentStatus.PAID && <Pill label={paymentStatus} variant="positive" />}
    {(paymentStatus === PaymentStatus.PENDING_PAYMENT || paymentStatus === PaymentStatus.NA) && (
      <Pill label={paymentStatus} variant="info" />
    )}
  </>
);

export default PaymentStatusPill;
